var _circle, _path, _path2, _path3, _path4, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgWhatsapp = function SvgWhatsapp(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 32,
    r: 32,
    fill: "url(#paint0_linear_300_11756)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.4946 44.9727L24.0693 45.3116C26.4832 46.7378 29.2509 47.4923 32.0734 47.4935H32.0793C40.7471 47.4935 47.8013 40.4724 47.8049 31.8428C47.8064 27.661 46.1722 23.7286 43.2032 20.7704C41.7469 19.3116 40.0145 18.1548 38.1061 17.367C36.1978 16.5792 34.1514 16.176 32.0855 16.1808C23.411 16.1808 16.3566 23.2012 16.3535 31.8303C16.3492 34.7769 17.1827 37.6645 18.7576 40.1593L19.1318 40.7512L17.5428 46.5261L23.4946 44.9727ZM13 51L15.6844 41.2427C14.0289 38.3873 13.1579 35.1478 13.1589 31.829C13.1633 21.4465 21.6503 13 32.0796 13C37.1406 13.0026 41.8909 14.9633 45.4635 18.5225C49.0361 22.0817 51.0018 26.8126 51 31.8441C50.9954 42.2258 42.5071 50.6739 32.0793 50.6739H32.0711C28.9048 50.6726 25.7935 49.8818 23.0299 48.3816L13 51Z",
    fill: "#B3B3B3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13 51L15.6844 41.2427C14.026 38.3804 13.1549 35.1333 13.1589 31.829C13.1633 21.4465 21.6503 13 32.0796 13C37.1406 13.0026 41.8909 14.9633 45.4635 18.5225C49.0361 22.0817 51.0018 26.8126 51 31.8441C50.9954 42.2258 42.5071 50.6739 32.0793 50.6739H32.0711C28.9048 50.6726 25.7935 49.8818 23.0299 48.3816L13 51Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M32.0059 16C23.7318 16 17.003 22.9503 17 31.4932C16.9959 34.4103 17.791 37.2691 19.2932 39.739L19.65 40.3253L18.1344 46.0425L23.8117 44.5043L24.3599 44.8399C26.6624 46.2518 29.3024 46.9985 31.9946 47H32.0002C40.2679 47 46.9967 40.049 46.9999 31.5056C47.0062 29.4693 46.6214 27.452 45.868 25.5704C45.1146 23.6888 44.0074 21.9803 42.6106 20.5438C41.2216 19.0995 39.569 17.9542 37.7487 17.1743C35.9284 16.3943 33.9765 15.9952 32.0059 16Z",
    fill: "url(#paint1_linear_300_11756)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.0851 23.8361C26.7163 23.041 26.3282 23.0249 25.9778 23.0112L25.0345 23C24.7064 23 24.1732 23.1195 23.7224 23.5974C23.2717 24.0753 22 25.2304 22 27.5798C22 29.9292 23.7634 32.1993 24.0091 32.5183C24.2548 32.8372 27.4133 37.8121 32.4151 39.7261C36.5717 41.3168 37.4175 41.0004 38.3201 40.921C39.2227 40.8415 41.2315 39.7659 41.6413 38.6508C42.0511 37.5357 42.0514 36.5804 41.9285 36.3807C41.8057 36.1809 41.4775 36.0622 40.985 35.8232C40.4925 35.5843 38.0736 34.4292 37.6226 34.2697C37.1716 34.1102 36.8437 34.031 36.5152 34.5089C36.1868 34.9869 35.2449 36.062 34.9577 36.3807C34.6705 36.6994 34.3838 36.7394 33.8913 36.5007C33.3988 36.262 31.8142 35.7575 29.9341 34.1308C28.4714 32.865 27.4839 31.3019 27.1965 30.8242C26.909 30.3466 27.1659 30.0879 27.4127 29.8499C27.6336 29.6359 27.9047 29.2923 28.1512 29.0136C28.3977 28.7349 28.4789 28.5356 28.6427 28.2175C28.8065 27.8993 28.7248 27.6198 28.6017 27.3811C28.4786 27.1424 27.5225 24.7805 27.0851 23.8361Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_300_11756",
    x1: 31.3485,
    y1: 3.84069,
    x2: 31.6729,
    y2: 58.5326,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#57D163"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#23B33A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_300_11756",
    x1: 31.6946,
    y1: 17.8603,
    x2: 31.857,
    y2: 44.3517,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#57D163"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#23B33A"
  })))));
};
export default SvgWhatsapp;